import { Types } from "assets/theme/base/boxShadows";
import { HMO, HMOType } from "constants/hmo";

/**
 * HMO Box Shadow Overrides
 * Defines box shadow customizations for each HMO portal
 * 
 * React 19 Best Practice: Pre-computed module-level constants
 * Since HMO is detected once and never changes, we pre-compute all possible values
 * This eliminates runtime computation and aligns with React 19's immutable patterns
 */

// Pre-computed HMO box shadow constants (React 19 best practice - compile-time constants)
const HMO_BOX_SHADOWS: Record<HMO, Partial<Types>> = {
  [HMO.LEUMIT]: {
    // Leumit-specific box shadow overrides can be added here
    // Example: modal: boxShadow([0, 12], [35, 0], black.main, 0.3), etc.
  },

  [HMO.MACCABI]: {
    // Macabi-specific box shadow overrides can be added here
  },

  [HMO.CLALIT]: {
    // Clalit-specific box shadow overrides can be added here
  },

  [HMO.MEUCHEDET]: {
    // Meuchedet-specific box shadow overrides can be added here
  },
  [HMO.CLINICAL_TRIAL]: {
    // Trial-specific box shadow overrides can be added here
  },
};

// Default (no HMO) - empty object
const DEFAULT_BOX_SHADOWS: Partial<Types> = {};

/**
 * Returns HMO-specific box shadow overrides (React 19 best practice - O(1) lookup from pre-computed constants)
 * @param hmo - HMO identifier or null for default
 * @returns HMO box shadow overrides or empty object for default theme
 */
export function getHmoBoxShadows(hmo: HMOType): Partial<Types> {
  if (!hmo) {
    return DEFAULT_BOX_SHADOWS;
  }
  
  return HMO_BOX_SHADOWS[hmo] || DEFAULT_BOX_SHADOWS;
}












